import * as React from 'react';
import { observer } from 'mobx-react';
import { DropDown, IDropDownProps } from './DropDown';
import { buildStoreDropdown } from '~utils/DropDownUtils';
import { IDropdownOption } from '~domain/entities/Config';

export interface ICmsDropDownProps extends Omit<IDropDownProps, 'options'> {
    dataList: string;
}

@observer
export class CmsDropDown extends React.Component<ICmsDropDownProps> {
    public render() {
        const { dataList, ...restProps } = this.props;

        return (
            <DropDown
                {...{
                    ...restProps,
                    options: buildStoreDropdown(dataList) as IDropdownOption[]
                }}
            />
        );
    }
}
